export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/5db655a2665f17f0aefac0388ce67987/b7e7a7b3c2379fba0c65fe2ec4b312e5.png"
              alt="Basic Rentals"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Providing affordable, reliable car rentals for gig workers and people with transportation challenges. 
              Quality vehicles at honest prices.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('fleet')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Our Fleet
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('rates')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Rates
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('booking')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Book Now
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:wayne@basicrentals.info"
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-mail-line"></i>
                  wayne@basicrentals.info
                </a>
              </li>
              <li className="text-gray-400 text-sm flex items-center gap-2">
                <i className="ri-price-tag-3-line"></i>
                $250/week
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Basic Rentals. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}